import script from "./UpdateReadyNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateReadyNotice.vue?vue&type=script&setup=true&lang=js"

import "./UpdateReadyNotice.vue?vue&type=style&index=0&id=a008f4c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a008f4c8"]])

export default __exports__